import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {GebaeudeEingangAdresseVersionDetailEntryMeta} from "../../../core/av-api";

export namespace GebaeudeEingangsadresseFormat {
  export type TypeEnum = 'GANZE_ADRESSE' | 'STRASSE';
}

@Pipe({
  name: 'kompaktVersionGebaeudeeingangsadresse'
})
export class KompaktVersionGebaeudeeingangsadressePipe extends KompaktdarstellungPipe<GebaeudeEingangAdresseVersionDetailEntryMeta> {

  constructor(protected formatConfigService: FormatConfigService, protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy) {
    super(formatConfigService, 'GEBAEUDEEINGANGSADRESSE', location, kompaktLocation);
  }

  transform(adresse: GebaeudeEingangAdresseVersionDetailEntryMeta, format: GebaeudeEingangsadresseFormat.TypeEnum = "GANZE_ADRESSE"): string {
    if (!adresse) {
      return '';
    }
    if (format === 'STRASSE') {
      return this.getStrasse(adresse);
    }
    if (this.formatElement === 'GEBAEUDEEINGANGSADRESSE_TYP00') {
      return this.getDefaultFormat(adresse);
    }
    // ...
    return this.getDefaultFormat(adresse);
  }

  getDefaultFormat(adresse: GebaeudeEingangAdresseVersionDetailEntryMeta) {
    const strasseHausnummer = [this.getStrasse(adresse), adresse.hausnummer].filter(val => val).join(' ');
    const ortschaft = [adresse.plz, adresse.ortschaft].filter(val => val).join(' ');
    return [strasseHausnummer, adresse.gebaeudeBezeichnung, ortschaft].filter(val => val).join(', ');
  }

  private getStrasse(adresse: GebaeudeEingangAdresseVersionDetailEntryMeta) {
    const strasse1 = adresse.strasse ? adresse.strasse.text : '';
    const strasse2 = adresse.strasse2 ? adresse.strasse2.text : '';
    let strasse = [strasse1, strasse2].filter(val => val).join('/');
    if (!strasse) {
      const benanntestGebiet1 = adresse.benanntesGebiet ? adresse.benanntesGebiet.text : '';
      const benanntestGebiet2 = adresse.benanntesGebiet2 ? adresse.benanntesGebiet2.text : '';
      strasse += [benanntestGebiet1, benanntestGebiet2].filter(val => val).join('/');
    }
    return strasse;
  }
}
